var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('div',{staticClass:"skill_type"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.model.data.name))]),_vm._l((_vm.model.findSkillList()),function(item,i){return _c('skill',{key:i,attrs:{"model":item}})})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }